<footer class="footer text-white p-1">

   <div class="container">
      <div class="d-flex justify-content-between">
         <span class="ms-2 text-white copy">Copyright &copy; {{currentYear}} - Southwestern Advantage</span>
         @if(!!signedIn())
         {
         <span class="ms-2 text-white copy">Logged-In: {{ signedIn() }}</span>
         }
      </div>
   </div>

</footer>
